import React from 'react';

export const FillPowerLeftImage = () => {
  return (
    <div className="il-add grey" data-beta-flow="true" style={{ backgroundImage: `url("/img/fillpower/fillpower-lower-one.jpg")`}}></div>
  );
};